import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import './index.css';
import startShell from './PreLoad';

startShell().catch((error) => {
    console.error('Failed to start shell', error);
});

window.React = React;
